import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPencil = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20.6705 3.3295C20.2312 2.89017 19.5189 2.89017 19.0795 3.3295L17.9224 4.48667L19.5133 6.07766L20.6705 4.9205C21.1099 4.48116 21.1099 3.76884 20.6705 3.3295ZM18.4527 7.13832L16.8617 5.54733L4.71087 17.6982C4.27031 18.1387 3.94646 18.6821 3.76859 19.2792L3.3646 20.6354L4.72079 20.2314C5.31792 20.0536 5.86131 19.7297 6.30187 19.2891L18.4527 7.13832ZM18.0189 2.26884C19.044 1.24372 20.706 1.24372 21.7312 2.26884C22.7563 3.29397 22.7563 4.95603 21.7312 5.98116L7.36253 20.3498C6.74574 20.9666 5.98499 21.42 5.14902 21.669L2.46413 22.4688C2.20021 22.5474 1.91442 22.4751 1.71969 22.2803C1.52496 22.0856 1.45261 21.7998 1.53123 21.5359L2.33101 18.851C2.58003 18.015 3.03342 17.2543 3.65021 16.6375L18.0189 2.26884Z",
		fill: "currentColor"
	})]
});
export default SvgPencil;
